import Amplify, { Storage } from "aws-amplify";
import { useEffect, useState } from "react";


export default function useGetProfilePicture(cognitoUsername) {

    const [url, setUrl] = useState(null);

    useEffect(() => {
        Storage.get(`profilePictures/${cognitoUsername}_profilePicture.png`)
            .then(url => {
                const myRequest = new Request(url);
                fetch(myRequest).then(function (response) {
                    if (response.status === 200) {
                        setUrl(url);
                    } else {
                        setUrl('/images/profilePictureDefault.svg');
                    }
                });
            })
    }, [cognitoUsername]);

    return url;

}